import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Editor, toDoc, toHTML, Toolbar } from "ngx-editor";
import { debounceTime, distinctUntilChanged, Subscription, switchMap } from "rxjs";
import { accordeonMe } from "src/app/animations";
import { CustomerService } from "src/app/services/customer.service";


@Component( {
	selector: "legal-document-editor",
	templateUrl: "./legal-document-editor.component.html",
	styleUrls: [ 'legal-document-editor.component.scss' ],
	animations: [ accordeonMe ],
} )
export class LegalDocumentEditorComponent implements OnInit {


	bExpanded = false;
	bSaving = false;
	bSavingError = false;

	editor = new Editor();
	toolbar: Toolbar = [
		[ 'bold', 'italic', 'underline', 'strike' ],
		[ 'ordered_list', 'bullet_list' ],
		[ { heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] } ],
		[ 'link', 'image' ],
		[ 'text_color', 'background_color' ],
		[ 'align_left', 'align_center', 'align_right', 'align_justify' ],
	];
	subscription = new Subscription();
	legalFormCtrl = new FormControl<Record<string, any>|null>( null );
	legalFormGroup = new FormGroup( {
		legalContent: this.legalFormCtrl,
	});

	@Input() legalType: "datenschutz"|"datenschutz-chat"|"nutzungsbedingungen"|"nutzungsbedingungen-chat"|"impressum"|"kontakt"|"invalid" = "invalid";
	@Input() set originalText( html: string ) {
		this.legalFormCtrl.setValue( toDoc( html ) );
	};
	@Input() title = "";
	@Input() placeholder = "";

	tmsLastSave: number|null = null;


	constructor(
		private customerService: CustomerService,
	) {}


	ngOnInit(): void {

		this.subscription.add(
			this.legalFormCtrl.valueChanges.pipe(
				debounceTime( 500 ),
				distinctUntilChanged(),
				switchMap( editorContent => {
					const html = editorContent ? toHTML( editorContent ) : "";
					this.bSaving = true;
					return this.customerService.saveLegalInformation( this.legalType, html );
				})
			).subscribe( b => {
				this.bSaving = false;
				this.bSavingError = !b;
				if( b ) {
					this.tmsLastSave = (new Date()).getTime();
				}
			})
		);
		
	}

	ngOnDestroy(): void {

		this.subscription.unsubscribe();

		this.editor.destroy();

	}

}